import React, { useEffect, useMemo, useState } from 'react';

import { Counter } from '@/components/counter/Counter';
import './calendar.css';

interface IVisitorsProps {
  reservation: {
    [key: string]: any;
    adultCount: number;
    incrementAdults: () => void;
    decrementAdults: () => void;
    childrenCount: number;
    incrementChildren: () => void;
    decrementChildren: () => void;
  };
}

export const Visitors = ({ reservation }: IVisitorsProps) => (
  <section className="w-full flex flex-col gap-6">
    <h3 className="text-md font-semibold cursor-default">Add visitors</h3>
    <div className="flex flex-col gap-3">
      <div className="flex flex-row justify-between items-center">
        <span className="font-inter text-md font-light cursor-default">Adults</span>
        <Counter
          count={reservation.adultCount}
          increment={reservation.incrementAdults}
          decrement={reservation.decrementAdults}
        />
      </div>
      <div className="flex flex-row justify-between items-center">
        <span className="font-inter text-md font-light cursor-default">Children</span>
        <Counter
          count={reservation.childrenCount}
          increment={reservation.incrementChildren}
          decrement={reservation.decrementChildren}
        />
      </div>
    </div>
  </section>
);
